import React from "react";
import {
  IonCard,
  IonCardTitle,
  IonCardContent,
  IonCardHeader,
  IonGrid,
  IonCol,
  IonRow,
  IonImg,
  IonButton
} from "@ionic/react";

export const Post = (props: { posts: any }) => {
  var date = "";
  var timestamp = "";
  var mindset = ""

  var title = "";
  var newtitle = "";
  var abbrtitle = "";
  var color = "";
  var id = "";
  var uid = "";

  var observation = "";
  var communication = "";
  var collaboration = "";
  var problemsolving = "";
  var curiosity = "";
  var responsibility = "";
  var empowerment = "";

  var obs_icon = "";
  var com_icon = "";
  var col_icon = "";
  var pro_icon = "";
  var cur_icon = "";
  var res_icon = "";
  var emp_icon = "";
  
  //secondary
  var wonderawe = "";
	var adventurousness = "";
	var respect = "";
	var empathy = "";
	var grit = "";
  var adaptability = "";
	var growthmindset = "";
	var focus = "";
	var datacollecting = "";
	var reasoning = "";
	var creativity = "";
  //var pdfPath = "https://expmindapp.wpengine.com/wp-content/uploads/pdf/";
  var pdfPath = "https://explorermindsetapp.com/wp-content/uploads/pdf/";
  var linkPath = "";

  //var content = "";
  if (props.posts.title !== undefined) {
    //title = props.posts.mtitle;
    //abbrtitle = title.replace(/\s/g, "-").toLowerCase();
    mindset = props.posts.mindset;
    console.log(mindset);

    title = props.posts.mtitle.replace(/[^\w\s]/gi, '');
    newtitle = title.replace(/\s+/g, ' ').trim()
    abbrtitle = newtitle.replace(/\s/g, "-").toLowerCase();

    date = props.posts.date;
    timestamp = props.posts.timestamp;
    id = props.posts.id;
    uid = props.posts.uid;
    color = props.posts.color;

    //secondary sklls
    wonderawe = props.posts.secondary.wonderawe;
    adventurousness = props.posts.secondary.adventurousness;
    respect = props.posts.secondary.respect;
    empathy = props.posts.secondary.empathy;
    grit = props.posts.secondary.grit;
    adaptability = props.posts.secondary.adaptability;
    growthmindset = props.posts.secondary.growthmindset;
    focus = props.posts.secondary.focus;
    datacollecting = props.posts.secondary.datacollecting;
    reasoning = props.posts.secondary.reasoning;
    creativity = props.posts.secondary.creativity;

    observation = props.posts.skills.observation;
    obs_icon = "../assets/images/icons/" + props.posts.icons.obsicon;
    communication = props.posts.skills.communication;
    com_icon = "../assets/images/icons/" + props.posts.icons.comicon;
    collaboration = props.posts.skills.collaboration;
    col_icon = "../assets/images/icons/" + props.posts.icons.comicon;
    problemsolving = props.posts.skills.problemsolving;
    pro_icon = "../assets/images/icons/" + props.posts.icons.proicon;
    curiosity = props.posts.attitudes.curiosity;
    cur_icon = "../assets/images/icons/" + props.posts.icons.curicon;
    responsibility = props.posts.attitudes.responsibility;
    res_icon = "../assets/images/icons/" + props.posts.icons.resicon;
    empowerment = props.posts.attitudes.empowerment;
    emp_icon = "../assets/images/icons/" + props.posts.icons.empicon;
    linkPath = pdfPath + abbrtitle + "_" + uid + "_" +  timestamp + ".pdf"; 
  
    console.log(abbrtitle);
    //content = props.post.content;
  }else{
    console.log("props" + props.posts);
    console.log("title - log" + props.posts.title);
  }
  return (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle><h3>{title}</h3><p>{date}</p></IonCardTitle>
        
      </IonCardHeader>
      <IonCardContent class="ion-text-start mindsetcontent" style={{paddingBottom:'80px'}}>
        <IonButton href={'/createmindmap?id='+id}>Create MindMap</IonButton>
        <IonButton href={linkPath} target="_blank">Download Pdf</IonButton>
        <IonGrid>
        {(function() {
            if(mindset){//optional rows.
              return(  
                <>
                <IonRow><IonCol><h2>My Mindset</h2></IonCol></IonRow>
                <IonRow class="ion-row">
                  <IonCol size="4"><IonImg class="iconimg" src={'../assets/images/Explorer-Mindset-App-Logo.png'} style={{background:'#FFF'}}/></IonCol>
                  <IonCol size="8"><p>{mindset}</p></IonCol>
                </IonRow>
                <br/>
              
                </>
              );}
          })()}
        {(function() {
          if(curiosity || responsibility || empowerment){//optional rows.
            return(  
              <>
              <h1>Attitudes</h1>
              </>
            )
          }
        })()}
          {(function() {
            if(curiosity){//optional rows.
              return(  
                <>
                <IonRow><IonCol><h2>Curiosity</h2></IonCol></IonRow>
                <IonRow class="ion-row">
                  <IonCol size="4"><IonImg class="iconimg" src={cur_icon} style={{background:color}}/></IonCol>
                  <IonCol size="8"><p>{curiosity}</p></IonCol>
                </IonRow>
                <br/>
                </>
              );}
          })()}
          {(function() {
              if(wonderawe){
                return(
                  <>
                  <IonRow><IonCol><h2>Wonder/Awe</h2></IonCol></IonRow>
                  <IonRow><IonCol>
                  {wonderawe}
                  </IonCol></IonRow>
                  </>
                );}
          })()}
          {(function() {
              if(adventurousness){
                return(
                  <>
                  <IonRow><IonCol><h2>Adventurousness</h2></IonCol></IonRow>
                  <IonRow><IonCol>
                  {adventurousness}
                  </IonCol></IonRow>
                  </>
                );}
                
            
          })()}
          {(function() {
            if(responsibility){//optional rows.
              return(  
                <>
                <IonRow><IonCol><h2>Responsibility</h2></IonCol></IonRow>
                <IonRow class="ion-row">
                  <IonCol size="4"><IonImg class="iconimg" src={res_icon} style={{background:color}}/></IonCol>
                  <IonCol size="8"><p>{responsibility}</p></IonCol>
                </IonRow>
                </>
              );}
          })()}
          {(function() {
              if(respect){
                return(
                  <>
                  <IonRow><IonCol><h2>Respect</h2></IonCol></IonRow>
                  <IonRow><IonCol>
                  {respect}
                  </IonCol></IonRow>
                  </>
                );}
          })()}
          {(function() {
              if(empathy){
                return(
                  <>
                  <IonRow><IonCol><h2>Empathy</h2></IonCol></IonRow>
                  <IonRow><IonCol>
                  {empathy}
                  </IonCol></IonRow>
                  </>
                );}
          })()}
          {(function() {
            //if(curiosity !== ""){//optional rows.
            if(empowerment){//optional rows.
              return(  
                <>
                <IonRow><IonCol><h2>Empowerment</h2></IonCol></IonRow>
                <IonRow class="ion-row">
                  <IonCol size="4"><IonImg class="iconimg" src={emp_icon} style={{background:color}}/></IonCol>
                  <IonCol size="8"><p>{empowerment}</p></IonCol>
                </IonRow>
                </>
              );}
          })()}
           {(function() {
              if(grit){
                return(
                  <>
                  <IonRow><IonCol><h2>Grit</h2></IonCol></IonRow>
                  <IonRow><IonCol>
                  {grit}
                  </IonCol></IonRow>
                  </>
                );}
          })()}
          {(function() {
              if(adaptability){
                return(
                  <>
                  <IonRow><IonCol><h2>Adaptability</h2></IonCol></IonRow>
                  <IonRow><IonCol>
                  {adaptability}
                  </IonCol></IonRow>
                  </>
                );}
          })()}
          {(function() {
              if(growthmindset){
                return(
                  <>
                  <IonRow><IonCol><h2>Growth Mindset</h2></IonCol></IonRow>
                  <IonRow><IonCol>
                  {growthmindset}
                  </IonCol></IonRow>
                  </>
                );}
          })()}
          </IonGrid>
          <h1>Skills</h1>
          <IonGrid>
            
            <IonRow>
              <IonCol><h2>Observation</h2></IonCol>
            </IonRow>
            <IonRow class="ion-row">
              <IonCol size="4">
                <IonImg class="iconimg" src={obs_icon} style={{background:color}}/>
              </IonCol>
              <IonCol size="8">
              <p>{observation}</p>
              </IonCol>
            </IonRow>
            {(function() {
              if(focus){
                return(
                  <>
                  <IonRow><IonCol><h2>Focus</h2></IonCol></IonRow>
                  <IonRow><IonCol>
                  {focus}
                  </IonCol></IonRow>
                  </>
                );}
          })()}
          {(function() {
              if(datacollecting){
                return(
                  <>
                  <IonRow><IonCol><h2>Data Collecting</h2></IonCol></IonRow>
                  <IonRow><IonCol>
                  {datacollecting}
                  </IonCol></IonRow>
                  </>
                );}
          })()}
            <IonRow>
              <IonCol><h2>Communication</h2></IonCol>
            </IonRow>
            <IonRow class="ion-row">
              <IonCol size="4">
                <IonImg class="iconimg" src={com_icon} style={{background:color}}/>
              </IonCol>
              <IonCol size="8">
              <p>{communication}</p>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol><h2>Collaboration</h2></IonCol>
            </IonRow>
            <IonRow class="ion-row">
              <IonCol size="4">
                <IonImg class="iconimg"  style={{background:color}} src={col_icon}/>
              </IonCol>
              <IonCol size="8">
              <p>{collaboration}</p>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol><h2>Problem Solving</h2></IonCol>
            </IonRow>
            <IonRow class="ion-row">
              <IonCol size="4">
                <IonImg class="iconimg"  style={{background:color}} src={pro_icon}/>
              </IonCol>
              <IonCol size="8">
              <p>{problemsolving}</p>
              </IonCol>
            </IonRow>
            {(function() {
              if(problemsolving){
                return(
                  <>
                  <IonRow><IonCol><h2>Problem Solving</h2></IonCol></IonRow>
                  <IonRow><IonCol>
                  {problemsolving}
                  </IonCol></IonRow>
                  </>
                );}
          })()}
          {(function() {
              if(creativity){
                return(
                  <>
                  <IonRow><IonCol><h2>Creativity</h2></IonCol></IonRow>
                  <IonRow><IonCol>
                  {creativity}
                  </IonCol></IonRow>
                  </>
                );}
          })()}
          </IonGrid>
      </IonCardContent>
    </IonCard>
  );
};
